(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("TransferEmployeeModal", TransferEmployeeModal);

    TransferEmployeeModal.$inject = ['$scope', '$filter', '$timeout', 'modalData', 'onBoardingService', 'hUser', '$q', 'userServices'];

    function TransferEmployeeModal($scope, $filter, $timeout, modalData, onBoardingService, hUser, $q, userServices) {

        var self = this;
        var limit;
        var offset;
        var users,
            hasTeamScheduling,
            hasAutoImport;

        self.$onInit = function () {
            users = modalData.users || [];

            if (!users.length) {
                throw 'TransferEmployeeModal Need users to work';
            }

            self.sendObDocuments = true;
            self.formValidation = new (function () {
                BaseForm.call(this, 'move-employee-location', $scope);
            })();

            $timeout(function () {
                self.formValidation.onViewLoaded();
            }, 1);
        };

        self.getBrandsBySearchQuery = function ($event) {
            var defer = $q.defer();

            delete self.location;

            if ($event.value && $event.value.length >= 2) {
                $event.on('start');

                var contextBrandId = hUser.getUserContext().brand_id;
                limit = 200;
                offset = 0;

                onBoardingService
                    .getBrandsMoveTo(contextBrandId, offset, limit, $event.value)
                    .then(function (brands) {
                        var brandResult = brands;

                        if (users.length === 1) {
                            brandResult = brands.filter(function (brand) {
                                return brand.id !== users[0].brand_id;
                            });
                        }

                        defer.resolve(brandResult);
                        $event.on('end');
                    }, function (error) {
                        defer.reject(error);
                        $event.on('end');
                    });
            } else {
                defer.reject({code: "MIN_LENGTH"});
                $event.on('end');
            }

            return defer.promise;
        };

        self.close = function () {
            $scope.$hide();
        };

        self.moveEmployees = function () {
            if (self.formValidation.validator.validate()) {
                self.modalStatus = 'moving';

                var usersCopy = angular.copy(users);

                if (usersCopy[0]) {
                    if (usersCopy[0].default_prospects) {
                        usersCopy.map(function (employee) {
                            employee.prospect_id = employee.default_prospects[0];
                            employee.cardId = employee.id;
                            employee.id = employee.user_id;
                        });
                    }
                }
                var prospectIds = usersCopy.map(function (user) {
                    return user.prospect_id;
                });

                var contextBrandId = hUser.getUserContext().brand_id;

                onBoardingService
                    .moveEmployeeLocation(contextBrandId, self.location.id, prospectIds)
                    .then(function (response) {
                        response.failed_prospects = response.failed_prospects || [];

                        var failedProspects = response.failed_prospects.reduce(function (mappedPros, pros) {
                            mappedPros[pros.id] = pros;
                            return mappedPros;
                        }, {});

                        var userDetailsMap = {};

                        for (var i in usersCopy) {
                            userDetailsMap[usersCopy[i].prospect_id] = onBoardingService.getUserDetails(usersCopy[i].id) || usersCopy[i];
                        }

                        var failedNumberPros = Object.keys(failedProspects).length;
                        var afterMoveMessage = "";

                        var hintMessage;
                        if (!hasTeamScheduling && !hasAutoImport) {
                            hintMessage = $filter('translate')('employee(s) were transferred successfully. Their records will now be found under the location they have been moved to.');
                        } else if (hasTeamScheduling && !hasAutoImport) {
                            hintMessage = $filter('translate')('employee(s) were transferred successfully. Their records will be found under the old location which can be amended in TeamLive.')
                        } else if (hasTeamScheduling && hasAutoImport) {
                            hintMessage = $filter('translate')('employee(s) were transferred successfully. Their records will be found under the old location and the new location which can be amended in TeamLive.')
                        } else {
                            hintMessage = $filter("translate")("employee was transferred successfully.");
                        }

                        if (usersCopy.length > 1) {
                            afterMoveMessage = (usersCopy.length - failedNumberPros) + " " + $filter("translate")("out of") + " " + usersCopy.length + " " + hintMessage;

                            if (failedNumberPros > 0) {

                                if (failedNumberPros > 0) {
                                    afterMoveMessage += " " + $filter("translate")("Check the failed ones below.") + "<br />";
                                }

                                afterMoveMessage += '<ul>';

                                for (var i in failedProspects) {
                                    var failed = failedProspects[i];

                                    afterMoveMessage += '<li>';
                                    afterMoveMessage += userDetailsMap[failed.id].first_name + ' ' + userDetailsMap[failed.id].last_name;

                                    if (failed.reason_code === 'DESTINATION_SAME_SOURCE') {
                                        afterMoveMessage += ' (' + $filter('translate')('Employee is currently existing on this location') + ')';
                                    }

                                    afterMoveMessage += '</li>';
                                }

                                afterMoveMessage += '</ul>';
                            }
                        } else {
                            if (failedNumberPros === 0) {

                                afterMoveMessage = $filter("translate")("The") + ' ' +  hintMessage;

                            } else {
                                afterMoveMessage = $filter("translate")("Failed transferring an employee.");
                            }
                        }


                        self.close();

                        hAlert({
                            button: {
                                text: self.sendObDocuments? $filter("translate")("Next"): $filter("translate")("Okay")
                            },
                            title:  $filter('translate')('Move Employees Status'),
                            text: afterMoveMessage,
                            custom_class: 'h-general-error-alert'
                        }, function () {
                            var actions = [];

                            for (var i in usersCopy) {
                                var user = onBoardingService.getUserDetails(usersCopy[i].id) || usersCopy[i];

                                var usersFromServicePositions = onBoardingService.getUsersPositions(usersCopy[i].brand_id, [usersCopy[i].id]);
                                var usersPositions = usersFromServicePositions[user.id] || user.positions;

                                if (!failedProspects[usersCopy[i].prospect_id]) {
                                    actions.push({
                                        sendObDocuments: self.sendObDocuments,
                                        user_id: user.id,
                                        positions: usersPositions,
                                        position: usersPositions[0],
                                        name: user.first_name + ' ' + user.last_name,
                                        prospect_id: usersCopy[i].prospect_id,
                                        cardId: usersCopy[i].cardId,
                                        default_prospects: [usersCopy[i].prospect_id],
                                        brand_id: self.location.id,
                                        first_name: user.first_name,
                                        last_name: user.last_name,
                                        brandDetails: self.location
                                    });
                                }
                            }

                            if (actions.length > 0) {
                                onBoardingService.trigger('employees-moved', 'MOVE_EMPLOYEE_LOCATION', {
                                    actions: actions
                                });
                            } else {
                                onBoardingService.trigger('employees-moved', 'MOVE_FAILED', {});
                            }
                        });

                        self.modalStatus = 'moved';
                    })
                    .catch(function (error) {
                        self.modalStatus = 'error-moving';
                        error = error || {};
                        error.data = error.data || {};
                        error.data.data = error.data.data || JSON.stringify(error, null, "   ");

                        var errorMessage = $filter('translate')('Error while moving employees');

                        if (error.data.data && error.data.data.code === 'MOVEMENT_NOT_ALLOWED_WHILE_TEAM_SCHEDULE_IS_ACTIVE') {
                            errorMessage = $filter("translate")("Some of the selected employees have CoreHR profiles to perform this action please access their profile directly from CoreHR");
                        }

                        if (error.data.status_code === 403) {
                            errorMessage = $filter("translate")("You don’t have enough permissions on the selected locations to complete the transfer.");
                        }

                        if(error.data.data === "UNAUTHORIZED_DUE_TO_BRAND_CLOSED_STATUS" ) {
                            errorMessage = $filter("translate")("Unable to complete as this location is now closed.");
                        }
                        hAlert(
                            $filter('translate')('Something went wrong'),
                            errorMessage,
                            function () {
                            },
                            'h-general-error-alert'
                        );
                    });
            }
        };

        self.toggleLocation = function (items) {
            delete self.location;

            if (items && items.length) {
                self.location = items && items[0];
            }

            self.getNote();
        };

        self.getNote = function () {

            if (!self.location) {
                return;
            }

            self.msg = '';

            var promises = {};
            promises['hasTeamScheduling'] = userServices.isServiceEnabled(userServices.SERVICES.TEAM_SCHEDULING, self.location.id);
            promises['hasAutoImport'] = userServices.isServiceEnabled(userServices.SERVICES.TEAM_AUTO_IMPORT, self.location.id);

            self.loadingNote = true;

            $q.all(promises)
                .then(function (res) {
                    hasTeamScheduling = res['hasTeamScheduling'];
                    hasAutoImport = res['hasAutoImport'];

                    if (!hasTeamScheduling && !hasAutoImport) {
                        self.msg = $filter('translate')('Once complete, the employee(s) record will be found under the location you are moving them to.');
                    } else if (hasTeamScheduling && !hasAutoImport) {
                        self.msg = $filter('translate')('On TeamLive the employee(s) record will be kept on the current location. Any further amendments to the location can be managed within TeamLive.')
                    } else if (hasTeamScheduling && hasAutoImport) {
                        self.msg = $filter('translate')('On TeamLive the employee(s) record will be kept on the current location and added to the new location. Any further amendments to the location can be managed within TeamLive.')
                    }

                })
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    self.loadingNote = false;
                });

        };

        self.$onInit();
    }
})();
